import { SubscribeAPIMessageType } from '@/types';

export type TranslatedAPIMessageSentimentType =
  | 'success'
  | 'failure'
  | 'warning'
  | 'neutral';

export type TranslatedAPIMessageType = {
  humanMessage: string;
  addContactLink: boolean;
  sentiment: TranslatedAPIMessageSentimentType;
};

export const HUMANIZED_API_RESPONSES = {
  unknown:
    'An unknown error occurred and we were unable to subscribe you at this time.',
  invalidOrFailedRequest: `Our system was unable to subscribe you at this time.`,
  invalidReCaptcha:
    "We couldn't confirm you're a real user. Please refresh and try again.",
  existingSubscriber: 'You are already subscribed.',
  invalidEmail: 'That appears to be an invalid email address.',
  blocked: `Our system was unable to subscribe you at this time.`,
  subscribed: 'Subscribed! Look for us in your inbox soon.',
};

export function translateAPIMessage(
  apiMessage: SubscribeAPIMessageType | undefined,
): TranslatedAPIMessageType {
  switch (apiMessage) {
    case 'invalid_request':
    case 'failed':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.invalidOrFailedRequest,
        addContactLink: true,
        sentiment: 'failure',
      };

    case 'invalid_recaptcha':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.invalidReCaptcha,
        addContactLink: false,
        sentiment: 'failure',
      };

    case 'existing_subscriber':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.existingSubscriber,
        addContactLink: false,
        sentiment: 'neutral',
      };

    case 'blocked_subscriber':
    case 'blocked_email':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.blocked,
        addContactLink: true,
        sentiment: 'failure',
      };

    case 'invalid_email':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.invalidEmail,
        addContactLink: true,
        sentiment: 'failure',
      };

    case 'subscribed':
      return {
        humanMessage: HUMANIZED_API_RESPONSES.subscribed,
        addContactLink: false,
        sentiment: 'success',
      };

    default:
      return {
        humanMessage: HUMANIZED_API_RESPONSES.unknown,
        addContactLink: true,
        sentiment: 'failure',
      };
  }
}
